export default "__VITE_ASSET__5887b46f__"